module.exports = __webpack_public_path__ + "img/farmers-down.4160544.svg";